import { useRef } from 'react';
import { Box } from '@chakra-ui/react';

import Alert from 'UiKit/alert';
import useGetSchedule from 'Domain/schedule/useGetSchedule';

import Calendar from 'View/schedule/section/calendar';
import Filter from 'View/schedule/section/filter';
import FormUpsert from 'View/schedule/section/form-upsert';
import Head from 'View/schedule/section/head';
import FormUpload from 'View/schedule/section/form-upload';
import DrawerDetailSchedule from 'View/schedule/section/drawer-detail-schedule';
import ScheduleProvider from 'View/schedule/state';
import { useScheduleState } from 'View/schedule/state';

import styles from './styles.module.css';

const Schedule = () => {
  const calendarRef = useRef();
  const { state, filterState } = useScheduleState();
  const { data: scheduleData, isFetching } = useGetSchedule(filterState);

  return (
    <Box className={styles['schedule__container']}>
      <Head scheduleData={scheduleData} />
      <Alert {...state?.alertProps} marginBottom="12px" />
      <Filter />
      <Calendar calendarRef={calendarRef} scheduleData={scheduleData} isFetching={isFetching} />

      <FormUpsert />
      <FormUpload />
      <DrawerDetailSchedule />
    </Box>
  );
};

const ScheduleContainer = () => <ScheduleProvider children={<Schedule />} />;

export default ScheduleContainer;
